/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface TopClassRow
 */
export interface TopClassRow {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof TopClassRow
     */
    classId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof TopClassRow
     */
    className: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof TopClassRow
     */
    enrollmentsCount: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the TopClassRow interface.
 */
export function instanceOfTopClassRow(value: object): value is TopClassRow {
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('className' in value) || value['className'] === undefined) return false;
    if (!('enrollmentsCount' in value) || value['enrollmentsCount'] === undefined) return false;
    return true;
}

export function TopClassRowFromJSON(json: any): TopClassRow {
    return TopClassRowFromJSONTyped(json, false);
}

export function TopClassRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopClassRow {
    if (json == null) {
        return json;
    }
    return {
        
        'classId': ApiUserTasksGetPageParameterFromJSON(json['classId']),
        'className': json['className'],
        'enrollmentsCount': ApiUserTasksGetPageParameterFromJSON(json['enrollmentsCount']),
    };
}

export function TopClassRowToJSON(json: any): TopClassRow {
    return TopClassRowToJSONTyped(json, false);
}

export function TopClassRowToJSONTyped(value?: TopClassRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classId': ApiUserTasksGetPageParameterToJSON(value['classId']),
        'className': value['className'],
        'enrollmentsCount': ApiUserTasksGetPageParameterToJSON(value['enrollmentsCount']),
    };
}

